// frontend/src/utils/networkErrorMessage.js
// ネットワーク起因の失敗をユーザー向けの統一文言に寄せる薄い共通層。
// Mobile 参照実装（mobile/src/services/networkErrorUi.js の OFFLINE_MESSAGE /
// shouldUseGlobalNetworkError）と文言・分類の考え方を揃える。既存の個別エラー
// 文言を大量に置換するのではなく、ネットワーク由来と判定できるものだけを
// 「通信環境をご確認ください」系へ寄せるために使う。

// Mobile connectivity.js の OFFLINE_MESSAGE と同一文言。
export const OFFLINE_MESSAGE = 'オフラインのようです。通信環境をご確認ください。';

// 過渡的な通信不良（タイムアウト・一時的な切断など）向けの案内文言。
export const NETWORK_GUIDANCE_MESSAGE =
  '通信環境をご確認ください。時間をおいて再度お試しください。';

const NETWORK_ERROR_PATTERNS = [
  'failed to fetch',
  'network request failed',
  'networkerror',
  'load failed',
  'offline',
  'オフライン',
  '通信環境',
  '通信状態',
  '通信できません',
  '通信がタイムアウト',
];

const resolveMessage = (errorOrMessage) => {
  if (!errorOrMessage) return '';
  if (typeof errorOrMessage === 'string') return errorOrMessage;
  return String(errorOrMessage.message || '');
};

// fetch 由来のネットワーク断（TypeError）やタイムアウト系メッセージを近似判定する。
// AbortError（呼び出し側キャンセル）はネットワークエラー扱いしない。
export function isLikelyNetworkError(errorOrMessage) {
  if (!errorOrMessage) return false;
  if (typeof errorOrMessage === 'object') {
    if (errorOrMessage.name === 'AbortError' || errorOrMessage.code === 20) return false;
    if (errorOrMessage.isNetworkError === true) return true;
    if (errorOrMessage instanceof TypeError) return true;
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return true;
  }
  const message = resolveMessage(errorOrMessage).toLowerCase();
  if (!message) return false;
  return NETWORK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

// ネットワーク起因なら統一文言、それ以外は元メッセージ（無ければ fallback）を返す。
export function toFriendlyErrorMessage(errorOrMessage, fallback = '') {
  if (isLikelyNetworkError(errorOrMessage)) return NETWORK_GUIDANCE_MESSAGE;
  return resolveMessage(errorOrMessage) || fallback;
}
